// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JB-U","colBig":"styles_colBig__cIYf6","colSmall":"styles_colSmall__2g2Yw","shopifyNameWrapper":"styles_shopifyNameWrapper__3oJa1"};